// import axios from "axios";
// import { toast } from "react-hot-toast";

// export const FETCH_USER_ATTENDANCE_REQUEST = "FETCH_USER_ATTENDANCE_REQUEST";
// export const FETCH_USER_ATTENDANCE_SUCCESS = "FETCH_USER_ATTENDANCE_SUCCESS";
// export const FETCH_USER_ATTENDANCE_FAILURE = "FETCH_USER_ATTENDANCE_FAILURE";

// export const FETCH_USER_ACTIVITY_REQUEST = "FETCH_USER_ACTIVITY_REQUEST";
// export const FETCH_USER_ACTIVITY_SUCCESS = "FETCH_USER_ACTIVITY_SUCCESS";
// export const FETCH_USER_ACTIVITY_FAILURE = "FETCH_USER_ACTIVITY_FAILURE";
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// export const fetchUserAttendance = (month) => async (dispatch) => {
//   dispatch({ type: FETCH_USER_ATTENDANCE_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const response = await axios.post(
//       `${BASE_URL}/v1/api/getUserAttendance`,
//       { month }, // { month: "2025-07" }
//       {
//         headers: {
//           authorization: token,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: FETCH_USER_ATTENDANCE_SUCCESS,
//       payload: response.data.data, // Adjust based on API response shape
//     });
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.message || error.message || "Failed to fetch attendance";

//     dispatch({
//       type: FETCH_USER_ATTENDANCE_FAILURE,
//       payload: errorMessage,
//     });

//     toast.error(errorMessage);
//   }
// };


// export const fetchUserActivity = (date) => async (dispatch) => {
//   dispatch({ type: FETCH_USER_ACTIVITY_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const response = await axios.get(
//       `${BASE_URL}/v1/api/user-activity?date=${date}`,
//       {
//         headers: {
//           Authorization: token,
//         },
//       }
//     );

//     dispatch({
//       type: FETCH_USER_ACTIVITY_SUCCESS,
//       payload: response.data?.data || [],
//     });
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.message || error.message || "Failed to fetch activity";

//     dispatch({
//       type: FETCH_USER_ACTIVITY_FAILURE,
//       payload: errorMessage,
//     });

//     toast.error(errorMessage);
//   }
// };

import axios from "axios";
import { toast } from "react-hot-toast";

// Attendance types
export const FETCH_USER_ATTENDANCE_REQUEST = "FETCH_USER_ATTENDANCE_REQUEST";
export const FETCH_USER_ATTENDANCE_SUCCESS = "FETCH_USER_ATTENDANCE_SUCCESS";
export const FETCH_USER_ATTENDANCE_FAILURE = "FETCH_USER_ATTENDANCE_FAILURE";

// Activity types
export const FETCH_USER_ACTIVITY_REQUEST = "FETCH_USER_ACTIVITY_REQUEST";
export const FETCH_USER_ACTIVITY_SUCCESS = "FETCH_USER_ACTIVITY_SUCCESS";
export const FETCH_USER_ACTIVITY_FAILURE = "FETCH_USER_ACTIVITY_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Get attendance for full month
export const fetchUserAttendance = (month) => async (dispatch) => {
  dispatch({ type: FETCH_USER_ATTENDANCE_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/getUserAttendance`,
      { month }, // Format: "YYYY-MM"
      {
        headers: {
          authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_USER_ATTENDANCE_SUCCESS,
      payload: response.data.data, // Expecting array of attendance
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to fetch attendance";

    dispatch({
      type: FETCH_USER_ATTENDANCE_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

// Get single-day activity
export const fetchUserActivity = (date) => async (dispatch) => {
  dispatch({ type: FETCH_USER_ACTIVITY_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/user-activity?date=${date}`, {
      headers: {
        authorization: token,
      },
    });

    dispatch({
      type: FETCH_USER_ACTIVITY_SUCCESS,
      payload: response.data.data, // Single day activity details
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to fetch activity";

    dispatch({
      type: FETCH_USER_ACTIVITY_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};
